"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Clock = _interopRequireDefault(require("../../Icons/Clock"));

var _InputBox = _interopRequireDefault(require("../../InputBox"));

var _TimeInput = _interopRequireDefault(require("../../TimeInput"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _getBoundedValue = _interopRequireDefault(require("../../../utils/numbers/getBoundedValue"));

var _roundTo = _interopRequireDefault(require("../../../utils/roundTo"));

var _durationToMilliseconds = _interopRequireDefault(require("../../../utils/time/durationToMilliseconds"));

var _millisecondsToDuration = _interopRequireDefault(require("../../../utils/time/millisecondsToDuration"));

var _durationToTimeString = _interopRequireDefault(require("../../../utils/time/durationToTimeString"));

var _useClickOutside = _interopRequireDefault(require("../../../hooks/useClickOutside"));

var _TimeOverlay = _interopRequireDefault(require("./TimeOverlay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t-webkit-appearance: none;\n\tbackground-color: white;\n\theight: 2.75rem;\n\tline-height: 2.75rem;\n\tpadding: 0 16px;\n\n\t@media (min-width: ", ") {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\tposition: relative;\n\n\t@media (min-width: ", ") {\n\t\tdisplay: block;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject(), _breakpoints.default.tablet);

Container.displayName = 'Container';
var MobileTimePicker = (0, _styledComponents.default)(_InputBox.default)(_templateObject2(), _breakpoints.default.tablet);
MobileTimePicker.displayName = 'MobileTimePicker';

var formatTimePart = function formatTimePart(v) {
  return v.toString().padStart(2, '0');
};

var TimePicker = function TimePicker(_ref) {
  var _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      value = _ref.value,
      minuteIncrements = _ref.minuteIncrements,
      hourIncrements = _ref.hourIncrements,
      min = _ref.min,
      max = _ref.max,
      GA = _ref.GA,
      rest = _objectWithoutPropertiesLoose(_ref, ["onChange", "onFocus", "onBlur", "value", "minuteIncrements", "hourIncrements", "min", "max", "GA"]);

  var _useState = (0, _react.useState)(false),
      pickerVisible = _useState[0],
      setPickerVisible = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      hasFocus = _useState2[0],
      setFocus = _useState2[1];

  var nodeRef = (0, _useClickOutside.default)(function () {
    return setPickerVisible(false);
  });

  var _useState3 = (0, _react.useState)((0, _durationToTimeString.default)(value)),
      internalValue = _useState3[0],
      setInternalValue = _useState3[1];

  (0, _react.useEffect)(function () {
    // keep internal value in sync with prop change
    setInternalValue((0, _durationToTimeString.default)(value));
  }, [value]);

  var changeHandler = function changeHandler(_ref2) {
    var newHours = _ref2.hours,
        newMinutes = _ref2.minutes;
    var proposedDate = new Date((0, _durationToMilliseconds.default)(value || {
      hours: 0,
      minutes: 0
    }));
    proposedDate.setUTCHours((0, _roundTo.default)(hourIncrements)((0, _getBoundedValue.default)(newHours, 0, 23)));
    proposedDate.setUTCMinutes((0, _roundTo.default)(minuteIncrements)((0, _getBoundedValue.default)(newMinutes, 0, 59)));
    var appliedValue = proposedDate.getTime();
    var boundedValue = (0, _getBoundedValue.default)(appliedValue, (0, _durationToMilliseconds.default)(min), (0, _durationToMilliseconds.default)(max));

    _onChange((0, _millisecondsToDuration.default)(boundedValue));
  };

  var blurHandler = function blurHandler() {
    // tries to apply current value, or the nearest valid number, even if it's incomplete
    if (internalValue.includes(':')) {
      var timeParts = internalValue.split(':');
      var latestValue = {
        hours: parseInt(timeParts[0], 10),
        minutes: parseInt(timeParts[1], 10)
      };

      if ((0, _durationToMilliseconds.default)(latestValue) !== (0, _durationToMilliseconds.default)(value)) {
        changeHandler(latestValue);
      }
    }
  };

  var valueAsString = (0, _durationToTimeString.default)(value);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(MobileTimePicker, {
    type: "time",
    onChange: function onChange(e) {
      var timeString = e.target.value;

      if (timeString.length === 5) {
        var timeParts = e.target.value.split(':');
        changeHandler({
          hours: parseInt(timeParts[0], 10),
          minutes: parseInt(timeParts[1], 10)
        });
      }
    },
    min: formatTimePart(min.hours) + ":" + formatTimePart(min.minutes),
    max: formatTimePart(max.hours) + ":" + formatTimePart(max.minutes),
    step: 60 * minuteIncrements,
    value: valueAsString
  }), _react.default.createElement(Container, {
    ref: nodeRef
  }, _react.default.createElement(_TimeInput.default, _extends({
    width: "120px",
    suffix: {
      icon: _Clock.default,
      color: _colors.default.primary,
      onClick: function onClick() {
        return setPickerVisible(!pickerVisible);
      }
    },
    onChange: function onChange(e) {
      var timeString = e.target.value;
      setInternalValue(timeString);

      if (!timeString.length) {
        _onChange(null);
      }

      if (timeString.length === 5) {
        var timeParts = e.target.value.split(':');
        changeHandler({
          hours: parseInt(timeParts[0], 10),
          minutes: parseInt(timeParts[1], 10)
        });
      }
    },
    onFocus: function onFocus(e) {
      // reset internal value
      if (internalValue !== (0, _durationToTimeString.default)(value)) {
        setInternalValue((0, _durationToTimeString.default)(value));
      }

      setFocus(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      blurHandler();
      setFocus(false);

      if (_onBlur) {
        _onBlur(e);
      }
    },
    value: hasFocus ? internalValue : valueAsString
  }, rest)), pickerVisible && _react.default.createElement(_TimeOverlay.default, {
    value: value || {
      hours: 0,
      minutes: 0
    },
    onChange: changeHandler,
    onHide: function onHide() {
      return setPickerVisible(false);
    },
    hourIncrements: hourIncrements,
    minuteIncrements: minuteIncrements,
    min: min,
    max: max
  })));
};

var duration = (0, _propTypes.shape)({
  hours: _propTypes.number,
  minutes: _propTypes.number
});
TimePicker.propTypes = {
  value: duration,
  onChange: _propTypes.func.isRequired,
  onFocus: _propTypes.func,
  onBlur: _propTypes.func,
  min: duration,
  max: duration,
  minuteIncrements: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  hourIncrements: _propTypes.number,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  })
};
TimePicker.defaultProps = {
  value: {
    hours: 0,
    minutes: 0
  },
  onFocus: undefined,
  onBlur: undefined,
  min: {
    hours: 0,
    minutes: 0
  },
  max: {
    hours: 23,
    minutes: 59
  },
  minuteIncrements: 1,
  hourIncrements: 1,
  GA: undefined
};
var _default = TimePicker;
exports.default = _default;